import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileLikeObject } from '@aptitude/angular-pipes';

@Component({
    selector: 'app-file-status-list',
    templateUrl: './file-status-list.component.html',
    styleUrls: ['./file-status-list.component.scss'],
    standalone: false
})
export class FileStatusListComponent {
  @Input() fileList!: Array<FileLikeObject>;
  @Input() deleteAllowed = false;
  @Input() downloadAllowed = false;
  @Output() fileToDelete = new EventEmitter<string>();

  onDelete($event: Event, fileId?: string) {
    $event.stopPropagation();
    this.fileToDelete.emit(fileId);
  }
}
